import React from 'react';
import config from '../../config';

const SubscriptionLogo = ({ height }) => (
  <img src={`${config.s3BucketUrl}/subscriptions/photobook_pass_logo_color.png`}
       height={height}/>
);

export default SubscriptionLogo;



// WEBPACK FOOTER //
// ./src/Common/SubscriptionLogo.js